import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { marked } from 'marked';
import { sanitizeDangerousText } from '@aidkitorg/types/lib/utils/textSanitizer';
function decodeExplainText(encodedText) {
    try {
        return decodeURIComponent(encodedText);
    }
    catch {
        return encodedText;
    }
}
function splitOnTables(html) {
    const segments = [];
    const tableRegex = /<table[\s\S]*?<\/table>/gi;
    let lastIndex = 0;
    let match;
    while ((match = tableRegex.exec(html)) !== null) {
        if (match.index > lastIndex) {
            segments.push({ type: 'html', content: html.slice(lastIndex, match.index) });
        }
        segments.push({ type: 'table', content: match[0] });
        lastIndex = match.index + match[0].length;
    }
    if (lastIndex < html.length) {
        segments.push({ type: 'html', content: html.slice(lastIndex) });
    }
    return segments;
}
export function nonHookMarkdown(str, collapsible, noParagraphs, replaceWithHtml, textAlign, tableRenderer, sanitize) {
    if (!str) {
        return _jsx("div", { className: "group group-hover:bg-blue" });
    }
    const renderer = new marked.Renderer();
    const linkRenderer = renderer.link;
    renderer.link = (paramhref, title, text) => {
        const href = paramhref ? paramhref : '';
        if (href.indexOf('https://www.youtube.com/watch?v=') === 0) {
            const matches = href.match(/https:\/\/www.youtube.com\/watch\?v=([^&]+)/);
            const id = matches ? matches[1] : '';
            if (!id)
                return `<a href="${href}">${text}</a>`;
            return `<iframe width="100%" height="315"
       src="https://www.youtube.com/embed/${id}"
       title="YouTube video player" frameborder="0"
       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        }
        ;
        const AUDIO = ['mp3', 'wav', 'ogg', 'flac', 'aac', 'm4a'];
        for (const ext of AUDIO) {
            if (text === '$audio' || href.toLowerCase().endsWith("." + ext)) {
                return `<audio controls src="${href}" />`;
            }
        }
        if (href.indexOf('https://explain?') === 0 || href.indexOf('https://explain/?') === 0) {
            const escaped = text;
            const escapedTooltip = sanitizeDangerousText(decodeExplainText(href.split('?')[1]));
            return `<span tabIndex=0 class="inline-block relative flex-col items-center group">
        <span class="info cursor-pointer border-t-0 border-l-0 border-r-0 border-b-2 border-dashed border-gray-300">${escaped}</span>
        <span class="absolute bottom-0 flex flex-col items-center mb-6 hidden group-focus:flex group-hover:flex z-50">
          <span class="relative z-10 p-2 text-xs text-white w-60 -ml-10 whitespace-no-wrap bg-black shadow-lg">${escapedTooltip}</span>
          <span class="w-3 h-3 -mt-2 -ml-10 transform rotate-45 bg-black"></span>
        </span>
      </span>`;
        }
        let html = linkRenderer.call(renderer, href, title, text);
        return html.replace(/^<a /, `<a target="_blank" rel="noreferrer noopener nofollow" `);
    };
    const firstHeader = {
        found: false,
        title: '',
        level: ''
    };
    if (collapsible) {
        const hrenderer = renderer.heading;
        renderer.heading = (text, level, raw, slugger) => {
            let html = hrenderer.call(renderer, text, level, raw, slugger);
            if (firstHeader.found) {
                return html;
            }
            firstHeader.found = true;
            firstHeader.title = html;
            firstHeader.level = 'h' + level;
            return '';
        };
    }
    let html = marked(str, { renderer, headerIds: false, mangle: false });
    html = html.replace(/<table([^>]*)>/gi, (_match, attrs) => {
        if (!/\btiptap-table\b/.test(attrs))
            return _match;
        return `<table${attrs.replace(/\s*style="[^"]*"/gi, '')}>`;
    });
    if (collapsible && !firstHeader.found) {
        const htmlHeadingMatch = html.match(/^(<h[1-6][^>]*>[\s\S]*?<\/h[1-6]>)\n?/i);
        if (htmlHeadingMatch) {
            firstHeader.found = true;
            firstHeader.title = htmlHeadingMatch[1];
            html = html.slice(htmlHeadingMatch[0].length);
        }
    }
    if (firstHeader.found) {
        html = `<div class="collapsible-toggle border-0 px-0 bg-white align-${textAlign} text-${textAlign}" role="button" tabindex="0" aria-expanded="false">${firstHeader.title}</div><div>${html}</div>`;
    }
    if (noParagraphs) {
        html = html.replace(/<p>/g, '').replace(/<\/p>/g, '');
    }
    if (replaceWithHtml) {
        html = html.replace(replaceWithHtml.regex, replaceWithHtml.html);
    }
    if (sanitize) {
        html = sanitize(html);
    }
    if (tableRenderer) {
        return (_jsx(_Fragment, { children: splitOnTables(html).map((seg, i) => seg.type === 'table'
                ? _jsx(React.Fragment, { children: tableRenderer(seg.content) }, i)
                : _jsx("div", { className: "markdown", dangerouslySetInnerHTML: { __html: seg.content } }, i)) }));
    }
    return _jsx("div", { className: "markdown", dangerouslySetInnerHTML: { __html: html } });
}
